import styled from 'styled-components';

export const Title = styled.h1``;

export const Subtitle = styled.h2``;
